import React from 'react';

const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-white">
      <div className="relative">
        {/* Elegant spinner */}
        <div className="w-12 h-12 rounded-full absolute border-4 border-gray-200"></div>
        <div className="w-12 h-12 rounded-full animate-spin absolute border-4 border-gray-900 border-t-transparent"></div>
      </div>
    </div>
  );
};

export default Loading;